import { render } from "./TabItem.vue?vue&type=template&id=e434024a"
import script from "./TabItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/TabItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e434024a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e434024a', __exports__)) {
    api.reload('e434024a', __exports__)
  }
  
  module.hot.accept("./TabItem.vue?vue&type=template&id=e434024a", () => {
    api.rerender('e434024a', render)
  })

}


export default __exports__